import styled, { css } from 'styled-components';

export const TimerContainer = styled.div<{ $mt: number; $hideTimer: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ $mt }) => $mt || 0}px;
  background-color: ${({ theme }) => theme.custom?.timerBg || '#E55656'};
  padding: 8px;
  border-radius: 8px;

  .icon {
    ${({ theme }) => (theme.isRtl ? 'margin-left: 8px;' : 'margin-right: 8px;')}
  }

  ${({ $hideTimer }) =>
    $hideTimer &&
    css`
      display: none;
    `}
`;

export const TimeWrapper = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #fff;

  span {
    display: inline-block;
    width: 40px;
    text-align: left;
    padding-left: 2px;
    color: #fff;
  }
`;
